import React from 'react';
import { PARAMS } from "../../../../config";

const TotalRow = ({ data }) => {
    const style = { fontSize: '18px', fontWeight: 'bold', textAlign: 'center' };
    const td = PARAMS.slice(4).map(([ param ]) => <td style={style} key={param}>{data[param]}</td>);

    return (
        <tr>
            <td colSpan={4} style={style}>Total</td>
            {td}
        </tr>
    );
};

export default TotalRow;


// WEBPACK FOOTER //
// ./src/scenes/BidderQuality/components/Table/components/TotalRow/index.js